<template>
  <div v-if="orders">
    <el-form style="margin: 10px" label-position="top">
      <el-form-item>
        <h3 style="margin: 0; padding: 0">消费项目</h3>
      </el-form-item>
      <el-form-item>
        <el-table
          ref="multipleTable"
          row-key="id"
          stripe
          :row-class-name="tableRowClassName"
          v-on:selection-change="handleSelectionChange"
          v-on:row-click="toggleSelection"
          :data="orders"
          style="width: 100%"
        >
          <el-table-column type="selection" width="45" align="center"></el-table-column>
          <el-table-column prop="orderNo" label="订单号"></el-table-column>
          <el-table-column label="订单类型">
            <template #default="scope">
              {{ getResourceType(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column prop="resourceTitle" label="名称"></el-table-column>
          <el-table-column label="金额">
            <template #default="scope">￥{{ scope.row.amount.toFixed(2) }}</template>
          </el-table-column>
          <el-table-column label="支付方式">
            <template #default="scope">
              {{ getChannel(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column prop="createdDate" label="支付时间" align="center"></el-table-column>
          <el-table-column align="center">
            <template #default="scope">
              <el-link :href="getUrl(scope.row)" :underline="false" target="_blank" type="primary">
                <i class="iconfont icon-externallink"></i>
                商品地址
              </el-link>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>

    <template v-if="amount > 0">
      <el-divider></el-divider>

      <el-alert type="info">
        每月25号之前，提交后3-5个工作日寄出； 每月25-30号，申请的发票将于次月初处理和寄出；
        订单开票后将不能申请该笔订单的退款，暂只提供12个月内消费的发票，若超出日期请联系客服
      </el-alert>

      <el-form style="margin: 10px" ref="form" :model="form" label-position="top">
        <el-form-item>
          <h3 style="margin: 0; padding: 0">发票信息</h3>
        </el-form-item>
        <el-form-item label="发票金额">￥{{ amount.toFixed(2) }}</el-form-item>
        <el-form-item label="发票类型" prop="type" :rules="{ required: true, message: '请选择发票类型' }">
          <el-radio-group v-model="form.type">
            <el-radio label="false-true">增值税普通发票（数电）</el-radio>
            <el-radio label="true-true">增值税专用发票（数电）</el-radio>
            <el-radio label="false-false">增值税普通发票（纸质）</el-radio>
            <el-radio label="true-false">增值税专用发票（纸质）</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="发票抬头" prop="taxTitle" :rules="{ required: true, message: '请输入发票抬头' }">
          <el-input v-model="form.taxTitle" placeholder="请输入发票抬头"></el-input>
        </el-form-item>
        <el-form-item
          label="纳税人识别号"
          prop="taxNo"
          :rules="{ required: true, message: '请输入纳税人识别号' }"
        >
          <el-input v-model="form.taxNo" placeholder="请输入纳税人识别号"></el-input>
        </el-form-item>
        <template v-if="isVatSpecial()">
          <el-form-item
            label="注册地址"
            prop="taxAddress"
            :rules="{ required: true, message: '请输入注册地址' }"
          >
            <el-input v-model="form.taxAddress" placeholder="请输入注册地址"></el-input>
          </el-form-item>
          <el-form-item
            label="电话"
            prop="taxTel"
            :rules="{ required: true, message: '请输入电话' }"
          >
            <el-input v-model="form.taxTel" placeholder="请输入电话"></el-input>
          </el-form-item>
          <el-form-item
            label="开户银行"
            prop="taxBankName"
            :rules="{ required: true, message: '请输入开户银行' }"
          >
            <el-input v-model="form.taxBankName" placeholder="请输入开户银行"></el-input>
          </el-form-item>
          <el-form-item
            label="银行帐号"
            prop="taxBankNo"
            :rules="{ required: true, message: '请输入银行帐号' }"
          >
            <el-input v-model="form.taxBankNo" placeholder="请输入银行帐号"></el-input>
          </el-form-item>
        </template>
        <template v-if="isElectronic()">
          <el-form-item>
            <h3 style="margin: 0; padding: 0">邮箱信息</h3>
          </el-form-item>
          <el-form-item label="电子邮箱" prop="email" :rules="[{ required: true, message: '请输入电子邮箱' },{ type: 'email', message: '请输入有效的电子邮箱' }]">
            <el-input v-model="form.email" placeholder="请输入电子邮箱"></el-input>
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item>
            <h3 style="margin: 0; padding: 0">邮寄信息</h3>
          </el-form-item>
          <el-form-item label="收件人姓名" prop="deliveryName" :rules="{ required: true, message: '请输入收件人姓名' }">
            <el-input v-model="form.deliveryName" placeholder="请输入收件人姓名"></el-input>
          </el-form-item>
          <el-form-item label="收件人电话" prop="deliveryTel" :rules="{ required: true, message: '请输入收件人电话' }">
            <el-input v-model="form.deliveryTel" placeholder="请输入收件人电话"></el-input>
          </el-form-item>
          <el-form-item label="收件人地址" prop="deliveryAddress" :rules="{ required: true, message: '请输入收件人地址' }">
            <el-input v-model="form.deliveryAddress" placeholder="请输入收件人地址"></el-input>
          </el-form-item>
        </template>

      </el-form>

      <el-divider></el-divider>
      <el-row style="margin: 10px">
        <el-col :span="24" align="center">
          <el-button type="primary" :disabled="amount == 0" :loading="isSubmitting" @click.prevent="btnSubmitClick">确 定</el-button>
        </el-col>
      </el-row>

      <div style="height: 30px"></div>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { IOrder } from '@/types/models';
import { IElForm, IElTable } from '@/types/element';
import utils from '@/utils';
import api from '@/api/my/invoices';

interface IForm {
  type: string;
  taxTitle: string;
  taxNo: string;
  taxAddress: string;
  taxTel: string;
  taxBankName: string;
  taxBankNo: string;
  deliveryName: string;
  deliveryTel: string;
  deliveryAddress: string;
  email: string;
}

interface IState {
  orders: IOrder[];
  multipleSelection: IOrder[];
  form: IForm;
  isSubmitting: boolean;
}

export default defineComponent({
  name: 'ApplyInvoice',
  data() {
    return {
      orders: [],
      multipleSelection: [],
      form: {
        type: 'false-false',
        taxTitle: '',
        taxNo: '',
        taxAddress: '',
        taxTel: '',
        taxBankName: '',
        taxBankNo: '',
        deliveryName: '',
        deliveryTel: '',
        deliveryAddress: '',
        email: '',
      },
      isSubmitting: false,
    } as IState;
  },
  methods: {
    apiGet() {
      api.get(
        {
          isApply: true,
        },
        (res) => {
          if (!res) return;

          this.orders = res.orders;
          if (res.lastInvoice) {
            this.form.type = `${res.lastInvoice.isVatSpecial}-${res.lastInvoice.isElectronic}`;
            // if (this.form.type !== 'false-false' && this.form.type !== 'true-false' && this.form.type !== 'true-false') {
            //   this.form.type = 'false-false';
            // }
            this.form.taxTitle = res.lastInvoice.taxTitle;
            this.form.taxNo = res.lastInvoice.taxNo;
            this.form.taxAddress = res.lastInvoice.taxAddress;
            this.form.taxTel = res.lastInvoice.taxTel;
            this.form.taxBankName = res.lastInvoice.taxBankName;
            this.form.taxBankNo = res.lastInvoice.taxBankNo;
            this.form.deliveryName = res.lastInvoice.deliveryName;
            this.form.deliveryTel = res.lastInvoice.deliveryTel;
            this.form.deliveryAddress = res.lastInvoice.deliveryAddress;
            this.form.email = res.lastInvoice.email;
          }
        },
      );
    },

    isVatSpecial() {
      if (this.form.type && this.form.type.indexOf('-') !== -1) {
        return this.form.type.split('-')[0] === 'true';
      }
      return false;
    },

    isElectronic() {
      if (this.form.type && this.form.type.indexOf('-') !== -1) {
        return this.form.type.split('-')[1] === 'true';
      }
      return false;
    },

    getResourceType(item: IOrder) {
      return utils.getResourceType(item.resourceType);
    },

    getChannel(item: IOrder) {
      return utils.getPayChannel(item.channel);
    },

    getUrl(item: IOrder) {
      if (item.resourceType === 'Theme') {
        return `/templates/template.html?resourceId=${item.resourceId}`;
      }
      if (item.resourceType === 'Extension') {
        return `/plugins/plugin.html?resourceId=${item.resourceId}`;
      }
      if (item.resourceType === 'Service') {
        return '/vip/#pricing';
      }
      return '#';
    },

    handleSelectionChange(val: IOrder[]) {
      this.multipleSelection = val;
    },

    toggleSelection(row: IOrder) {
      (this.$refs.multipleTable as IElTable).toggleRowSelection(row);
    },

    tableRowClassName(scope: { row: IOrder }) {
      if (this.multipleSelection.indexOf(scope.row) !== -1) {
        return 'current-row';
      }
      return '';
    },

    btnSubmitClick() {
      (this.$refs.form as IElForm).validate((valid) => {
        if (valid) {
          this.isSubmitting = true;
          api.submit(
            {
              ...this.form,
              isVatSpecial: this.isVatSpecial(),
              isElectronic: this.isElectronic(),
              orderNos: this.orderNos,
              amount: this.amount,
            },
            (res) => {
              if (!res.value) return;
              utils.success('发票申请成功！');
              this.apiGet();
              this.isSubmitting = false;
            },
            () => {
              this.isSubmitting = false;
            },
          );
        }
      });
    },
  },
  computed: {
    isChecked(): boolean {
      return this.multipleSelection.length > 0;
    },

    orderNos(): string[] {
      const retVal = [];
      for (let i = 0; i < this.multipleSelection.length; i += 1) {
        const item = this.multipleSelection[i];
        retVal.push(item.orderNo);
      }
      return retVal;
    },

    amount(): number {
      let retVal = 0;
      for (let i = 0; i < this.multipleSelection.length; i += 1) {
        const item = this.multipleSelection[i];
        retVal += item.amount;
      }
      return retVal;
    },
  },
  mounted() {
    this.apiGet();
  },
});
</script>
